import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from './components';
import * as loginSelectors from './../Login/Login.selectors';
import { Helmet } from 'react-helmet';
import * as selectors from './selectors';
import * as actions from './actions';
import Layout from './../Layout';

class Container extends Component {
    static propTypes = {
        user: PropTypes.object,
        fetchInformation: PropTypes.func,
        isFetchingInformation: PropTypes.bool,
        tags: PropTypes.array,
        points: PropTypes.array,
        anchors: PropTypes.array,
        distances: PropTypes.array,
        lines: PropTypes.array
    };

    componentDidMount() {
        const { fetchInformation } = this.props;
        fetchInformation(this.props.match.params.roomId);
        setInterval(() => {
            fetchInformation(this.props.match.params.roomId);
        }, this.props.match.params.interval);
    }

    render() {
        const { user, isFetchingInformation, tags, points, anchors, distances, lines } = this.props;
        return (
            <Layout>
                <div id="admin-dashboard-container" className="container-fluid">
                    <Helmet>
                        <title>UWB Room</title>
                        <meta name="description" content="" />
                    </Helmet>
                    <div className="row">
                        <div className="col">
                            <Table
                                user={user}
                                isFetchingInformation={isFetchingInformation}
                                tags={tags}
                                points={points}
                                anchors={anchors}
                                distances={distances}
                                lines={lines}
                                showDistances={this.props.match.params.showDistances}
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    user: loginSelectors.getUser,
    isFetchingInformation: selectors.getIsFetchingInformation,
    tags: selectors.getTags,
    points: selectors.getPoints,
    anchors: selectors.getAnchors,
    distances: selectors.getDistances,
    lines: selectors.getLines
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchInformation: (roomId) => dispatch(actions.fetchInformation(roomId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
